<div class="container">
  <div class="row justify-content-center">
    <div class="col-12 col-sm-8">
      <div class="bolder spacing">
        Roster Management
      </div>
      <div class="spacing spacing--sm">
        Filter the roster by Post Graduate Year using the filter option below. Click on column headers to sort the list accordingly.
      </div>
      <aaos-roster-table></aaos-roster-table>

    </div>
  </div>
</div>